<template>
	<div>
		
		<el-dialog title="编辑视频分类" width='500px' :visible.sync="showEditVideoClassify" :show-close='false' :close-on-click-modal='false'>
			<el-form label-width='80px'>
				<el-form-item label='分类图片'>
					<div class="classifyimg" v-if="VideoClassifyForm.img_url">
						<img :src="VideoClassifyForm.img_url" alt="">
						<div class="clearImgTr" @click='VideoClassifyForm.img_url=""'>
							<svg-icon icon-class='del' />
						</div>
					</div>
					<div class="addclassifyimg" @click='selectVideoClassifyImg' v-else><svg-icon icon-class='add' /></div>
				</el-form-item>
				<el-form-item label='分类标题'>
					<el-input v-model='VideoClassifyForm.title' placeholder='请输入分类标题' size='medium' style='width:300px'/>
				</el-form-item>
				<el-form-item label='添加至'>
					<el-select :disabled='VideoClassifyForm.classify_id? true:false' v-model="VideoClassifyForm.parent_id" style='width:300px' placeholder="请选择">
						<el-option v-if='item.parent_id==0' v-for="item in VideoClassifyStore" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<div class="btns">
					<el-button size='medium' type='primary' @click='editVideoClassifySuccess'>确定</el-button>
					<el-button size='medium' @click='$store.commit("hideeditVideoClassify",false)'>取消</el-button>
				</div>
			</el-form>
		</el-dialog>


		<el-dialog title="编辑视频" width='960px' :visible.sync="show_edit_video"  :close-on-click-modal='false'>
			<el-form label-width='100px' class='addGoodsDialog'>

				<el-tabs v-model="edit_video_section" tab-position="left">
					<el-tab-pane label="基础信息" name="basic">
						
						<el-form-item label='课程标题'>
							<el-input v-model='video_form.title' placeholder='请输入课程标题' size='small' style='width:300px' />
						</el-form-item>
						<el-form-item  label='简介'>
							<el-input v-model='video_form.introduction' :autosize="{ minRows: 3, maxRows: 10}" type='textarea' placeholder='请输入课程简介' size='small' style='width:500px'/>
						</el-form-item>
						<el-form-item label='课程主图'>
							<div class="addimg">
								<div class="goodlist">
									<div class="imgform" v-for='(goods,gi) in video_form.images' @click='video_form.images.splice(gi,1)'>
										<img :src="goods" alt="">
									</div>
								</div>
								<div v-if='video_form.images.length<1' class='addbtn'>
									<el-button  size='small' style='height: 35px;line-height: 35px;padding: 0' @click='add_video_img' >添加图片</el-button>
									<span style="color: #aaa"></span>
								</div>
							</div>
						</el-form-item>
						<el-form-item label='分类'>
							<el-cascader expand-trigger="hover" :props='{value:"id",label:"title"}' :options="VideoClassifyStore"  v-model="video_form.classify"></el-cascader>
							<!-- <el-button  size='small' style='margin-left: 20px'>添加分类</el-button> -->
						</el-form-item>
						<el-form-item  label='付费方式'>
							<el-checkbox label='一次性收费' v-model='video_form.all_price'></el-checkbox>
							<el-checkbox label='按章节收费' v-model='video_form.catalog_price'></el-checkbox>
							<el-popover placement="right" width="400" trigger="hover">
								<div>
									· 如果皆未勾选则不收费<br>
									· 当用户已购买了部分章节，仍可一次性付费购买全部内容，费用按（剩余章节/总价）计算
								</div>
								<svg-icon  slot="reference" style='width: 20px;height: 20px;color:#999' icon-class='question'/>
							</el-popover>
						</el-form-item>
						<el-form-item label='一次性收费' v-if='video_form.all_price'>
							<el-card  shadow="hover">
								<el-form-item label='原价/元'>
									<el-input v-model='video_form.price'   size='small' style='width:400px' >
										<el-button slot="append" @click='get_zhangjie_price'>获取章节总价格</el-button>
									</el-input>
								</el-form-item>
								<el-form-item label='价格/元'>
									<el-input v-model='video_form.promotional_price' placeholder='请输入视频促销价格'   size='small' style='width:400px'></el-input>
								</el-form-item>
							</el-card>
						</el-form-item>
						<el-form-item label='作者信息' >
							<el-card  shadow="hover" class='zhuozhe'>
								<el-form label-width='70px'>
									<el-form-item style='margin-bottom: 10px' label='头像' >
										<div class="head" @click='select_author_head'>
											<el-image v-if='video_form.author_head' :src='video_form.author_head'></el-image>
											<svg-icon v-else icon-class='add'/>
										</div>
									</el-form-item>
									<el-form-item style='margin-bottom: 10px' label='姓名' >
										<el-input size='medium' v-model='video_form.author_name'/>
									</el-form-item>
									<el-form-item style='margin-bottom: 10px' label='简介' >
										<el-input size='medium' type='textarea' :rows='5' v-model='video_form.author_desc'/>
									</el-form-item>
									<el-form-item style='margin-bottom: 10px' label='' >
										<el-button size='small'>导入名片</el-button>
									</el-form-item>
								</el-form>
							</el-card>
						</el-form-item>
						<el-form-item  label='库存'>
							<el-input  v-model='video_form.stock' type='text'  size='small' style='width:200px'>
							</el-input>
						</el-form-item>
						<el-form-item  label='虚拟订单数'>
							<el-input v-model='video_form.virtual' placeholder='' size='small' style='width:200px'></el-input>
						</el-form-item>
						<el-form-item  label='积分赠送'>
							<el-input v-model='video_form.gift_integral' placeholder='' size='small' style='width:200px'>
								<template slot="append">分</template>
							</el-input>
							<el-popover placement="right" width="400" trigger="hover">
								<div>
									会员购物赠送的积分, 如果不填写或填写0，则默认为不赠送积分，如果带%则为按成交价格的比例计算积分 <br><br>
									如: 购买2件，设置10 积分, 不管成交价格是多少， 则购买后获得20积分 <br><br>
									如: 购买2件，设置10%积分, 成交价格2 * 200= 400， 则购买后获得 40 积分（400*10%）<br><br>
									默认100积分抵扣1元，您可以在商城营销->积分修改
								</div>
								<svg-icon  slot="reference" style='width: 20px;height: 20px;color:#999' icon-class='question'/>
							</el-popover>

						</el-form-item>
						<el-form-item  label='积分抵扣'>
							<el-input v-model='video_form.deduction_integral' placeholder='' size='small' style='width:200px'>
								<template slot="append">分</template>
							</el-input>
							<el-popover placement="right" width="400" trigger="hover">
								<div>
									如果设置0，则不支持积分抵扣 如果带%则为按成交价格的比例计算抵扣多少元
								</div>
								<svg-icon  slot="reference" style='width: 20px;height: 20px;color:#999' icon-class='question'/>
							</el-popover>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="章节设置" name="zhangjie">
						<el-form-item label-width='0px'>
							<el-button size='mini' @click='$store.commit("add_section")'>添加章节</el-button>
							<el-card  shadow="hover">
								<el-tree :data="video_form.section" node-key="key" default-expand-all   >
									<span class="custom-tree-node" slot-scope="{ node, data }">
										<div class="video_tree">
											<div class="video_left">
												<div class="top">
													<el-input v-model='data.label' disabled style='width: 100px' size='mini' placeholder='序号：如第一章'/>
													<el-input v-model='data.title' style='width: 200px' size='mini' placeholder='输入视频标题'/>
													<span  v-if='data.level==1'>价格：<el-input v-model='data.price' :disabled='!video_form.catalog_price' title='开启按章节付费可设置' style='width: 130px' size='mini' placeholder='此章节费用（元）'/></span>
												</div>
												<div class='bottom' v-if='data.level==2'>
													<el-form-item label='选择视频'>
														<div class="blocks"  @click='select_video({node,data})'>
															<video v-if='data.video' :src="data.video"></video>
															<svg-icon v-else icon-class='add'/>
														</div>
													</el-form-item>
													<el-form-item label='视频封面'>
														<div class="blocks" @click='select_cover({node,data})'>
															<el-image v-if='data.image'  :src="data.image" fit="fit"></el-image>
															<svg-icon v-else icon-class='add'/>
														</div>
													</el-form-item>
												</div>
											</div>
											<span class="video_right">
												<el-button v-if='data.children' type="primary" size="mini" @click.stop='$store.commit("add_section",{node,data})'>添加</el-button>
												<el-button type="" size="mini" @click.stop='$store.commit("del_section",{node,data})'>删除</el-button>
											</span>

										</div>
									</span>
								</el-tree>
							</el-card>
						</el-form-item>

					</el-tab-pane>
					<el-tab-pane label="编辑详情" name="detail">

						<div class="editbox">
							<quill-editor style="min-height: 300px;width: 375px" v-model="video_form.details"  ref="myQuillEditor"  :options="editorGoodsOption">
							</quill-editor>
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-form>
			<div class="btns">
				<el-button size='medium' type='primary' @click='$store.commit("edit_video_success")'>确定</el-button>
				<el-button size='medium' @click='show_edit_video=false'>取消</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import { quillEditor ,Quill } from "vue-quill-editor"; 
	import {container,  QuillWatch} from 'quill-image-extend-module'
	let myContainer= [
	['bold', 'italic', 'underline', 'strike',{ 'indent': '-1'}, { 'indent': '+1' },"image"],   
	[{ 'color': [] }, { 'background': [] },{ 'header': [1, 2, 3, 4, 5, 6, false] }],
	];
	export default{
		components: {
			quillEditor
		},
		mounted(){
		},
		data(){
			return{
				edit_video_section:'basic',
				editorGoodsOption: {  
					modules: {
						toolbar: {
							container: myContainer,
							handlers: {
								'image': function () {
									_this.selectimgSuccess=function(){
										console.log(_this.myimg)
										_this.myimg.forEach((val,index)=>{
											if(val.check) 
												_this.goodsForms.details+='<img src="'+_this.siteUrl+val.url+'" />'
										})
										_this.showImgSelect=false;
									}
									_this.selectImg()
								}
							}
						}
					}
				},
			}
		},
		computed:{
			showEditVideoClassify(){
				return this.$store.state.video.showEditVideoClassify
			},
			VideoClassifyStore(){
				return this.$store.state.video.VideoClassifyStore
			},
			VideoClassifyForm(){
				return this.$store.state.video.VideoClassifyForm
			},
			show_edit_video:{
				get(){
					return this.$store.state.video.show_edit_video
				},
				set(){
					this.$store.commit("change_show_edit_video")
				}
			},
			video_form(){
				return this.$store.state.video.video_form
			},
		},
		methods:{
			select_author_head(){
				this.$store.commit("select_img",{
					mult:1,
					success:res=>{
						if(res[0]){
							this.video_form.author_head = res[0];
							this.$store.commit("reload_video_form")
						}
					}
				})
			},
			select_video(e){
				let index = e.data.key.split("-");

				this.$store.commit("select_img",{
					mult:1,
					type:'视频',
					success:res=>{
						if(res[0]){
							e.data.video = res[0];
							this.$store.commit("reload_video_form")
						}
					}
				})
			},
			select_cover(e){
				let index = e.data.key.split("-");

				this.$store.commit("select_img",{
					mult:1,
					success:res=>{
						if(res[0]){
							e.data.image = res[0]
							this.$store.commit("reload_video_form")
						}
					}
				})
			},
			get_zhangjie_price(){
				let total = 0;
				this.video_form.section.forEach(val=>{
					total+=parseFloat(val.price)
				})
				console.log(total)
				this.video_form.price = total;
				this.$store.commit("reload_video_form")
			},
			add_video_img(){
				this.$store.commit("select_img",{
					mult:1,
					success:res=>{
						this.video_form.images = res
					}
				})
			},
			selectVideoClassifyImg(){
				this.$store.commit("select_img",{
					mult:1,
					success:res=>{
						this.VideoClassifyForm.img_url = res
					}
				})
			},
			editVideoClassifySuccess(type){
				this.$store.commit("editVideoClassifySuccess")
			},
		}

	}
</script>

<style lang="scss" >
.zhuozhe{
	.head{
		width: 80px;
		height: 80px;
		border: 1px dashed #aaa;
		color: #aaa;
		overflow: hidden;
		border-radius: 2px;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.2s;
		cursor: pointer;
		.el-form-item{
			margin: 5px 0;
		}
		&:hover{
			border: 1px dashed #333;
			color: #333;
		}
	}
}
.video_tree{
	display: flex;
	width: 600px;
	.video_left{
		display: flex;
		flex-direction: column;
		width: 560px;
		.bottom{
			display: flex;
			padding: 10px;
			.blocks{
				width: 170px;
				height: 90px;
				overflow: hidden;
				display: flex;
				border: 1px dashed #ddd;
				border-radius: 4px;
				align-items: center;
				justify-content: center;
			}
		}
	}
	.video_right{
		margin-left: 10px;
	}
}
.el-tree-node__content{
	height: auto !important;
}
.classifyimg{
	width:80px;
	height: 80px;
	overflow: hidden;
	position: relative;
	img{
		width: 100%;
		min-height: 80px;
	}
	&:hover .clearImgTr{
		opacity: 1;
	}
	.clearImgTr{
		position: absolute;
		top: 0px;
		right: 0px;
		width: 100%;
		height: 100%;
		color: #fff;
		opacity: 0;
		overflow: hidden;
		background: rgba(0,0,0,0.4);
		font-size: 20px;
		transition: all 0.3s;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
}
.addclassifyimg{
	width:80px;
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 20px;
	cursor: pointer;
	border:1px dashed #aaa;
	transition: all 0.3s;
	&:hover{
		border:1px dashed #333;
		color: #333;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/video_dialog.vue